module.exports = __webpack_public_path__ + "img/Basic.81db370e.jpg";